// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA4XE3-uSKX-LiP6c0hO3SNmWYSsvLpv2A",
  authDomain: "agenda-e93b8.firebaseapp.com",
  databaseURL: "https://agenda-e93b8.firebaseio.com",
  projectId: "agenda-e93b8",
  storageBucket: "agenda-e93b8.appspot.com",
  messagingSenderId: "706347232072",
  appId: "1:706347232072:web:6e6da46b8e4149be8ba17d",
  measurementId: "G-FZNV63FNXL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;